module.exports = "pegasus/assets/themelp1/app/103.png";